export default class MathHelper {
  static calculateLinearTrend(x, ky, kx){
    let i = 0,
      nr = 0,
      dr = 0,
      ax = 0,
      ay = 0,
      a = 0,
      b = 0;
    function average(ar) {
      let r = 0;
      for (i = 0; i < ar.length; i++) {
        r = r + Number(ar[i]);
      }
      return r / ar.length;
    }
    ax = average(kx);
    ay = average(ky);
    for (i = 0; i < kx.length; i++) {
      nr = nr + (Number(kx[i]) - ax) * (Number(ky[i]) - ay);
      dr = dr + (Number(kx[i]) - ax) * (Number(kx[i]) - ax);
    }
    b = nr / dr;
    a = ay - b * ax;
    return a + b * x;
  };

  static calculateExponentialTrend(x, ky, kx){
    let i = 0,
      nr = 0,
      dr = 0,
      ax = 0,
      ay = 0,
      a = 0,
      b = 0;
    function average(ar) {
      let r = 0;
      for (i = 0; i < ar.length; i++) {
        r = r + Number(ar[i]);
      }
      return r / ar.length;
    }
    ax = average(kx);
    ay = average(ky);
    for (i = 0; i < kx.length; i++) {
      nr = nr + (Number(kx[i]) - ax) * (Number(ky[i]) - ay);
      dr = dr + (Number(kx[i]) - ax) * (Number(kx[i]) - ax);
    }
    b = nr / dr;
    a = ay - b * ax;
    return a + b * x;
  };
}